import { render, staticRenderFns } from "./HistoricalMerchantChannelTypeCount.vue?vue&type=template&id=55e297cc&"
import script from "./HistoricalMerchantChannelTypeCount.vue?vue&type=script&lang=ts&"
export * from "./HistoricalMerchantChannelTypeCount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HistoricalMerchantChannelTypeCount.vue"
export default component.exports